import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

const BASE_URL =
    "https://gestiondeflota.boltrack.net/apiultimamillav3/api/viaje";

export async function crearAlertaViaje(obj) {
    try {
        const { code, body, message } = await fetch(
            `${BASE_URL}/crear-alerta`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            return {
                error: false,
                id: body?.insertId ?? null,
                message: message ?? null,
            };
        }
        if (code === FAILURE) {
            return { error: true, message: message ?? "No se pudo crear la alerta" };
        }
        return { error: true, message: message ?? "No se pudo crear la alerta" };
    } catch (err) {
        console.log("crearAlertaViaje err");
        console.log(err);
        return { error: true, message: err?.message ?? String(err) };
    }
}

export async function deshabilitarAlertaViaje(id) {
    try {
        const { code, message } = await fetch(
            `${BASE_URL}/deshabilitar-alerta`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify({ id }),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            return { error: false, message: message ?? null };
        }
        if (code === FAILURE) {
            return { error: true, message: message ?? "No se pudo deshabilitar la alerta" };
        }
        return { error: true, message: message ?? "No se pudo deshabilitar la alerta" };
    } catch (err) {
        console.log("deshabilitarAlertaViaje err");
        console.log(err);
        return { error: true, message: err?.message ?? String(err) };
    }
}
